import {
  CHAMBER_BED_MOVED,
  CHAMBER_BED_CONTEXT_SELECTED,
  CHAMBER_BED_TRANSFORMED,
  CHAMBER_BED_CHAMBER_ROWS_REBUILD,
  CHAMBER_SET_CENTRALICED_COORDINATES,
  CHAMBER_BED_CLEAN,
  RESTORED_STATE_BED_RENDERED,
  IS_DIRTY,
  NUMBER_OF_FEED_CONNECTORS,
  POSITION_OF_INSPECTION_PORT
} from "../lib/types";

export const chamberBedMoved = (coordinates) => (dispatch) => {
  dispatch({
    type: CHAMBER_BED_MOVED,
    payload: coordinates,
  });
  dispatch({
    type: IS_DIRTY,
    payload: true,
  });
};

export const chamberBedSetCentralizedCoordinates = (coordinates) => (dispatch) => {
  dispatch({
    type: CHAMBER_SET_CENTRALICED_COORDINATES,
    payload: coordinates,
  });
};

export const chamberBedContextSelected = () => (dispatch) => {
  dispatch({
    type: CHAMBER_BED_CONTEXT_SELECTED,
  });
};

export const chamberBedTransformed = (transformations) => (dispatch) => {
  dispatch({
    type: CHAMBER_BED_TRANSFORMED,
    payload: transformations,
  });
  dispatch({
    type: IS_DIRTY,
    payload: true,
  });
};

export const chamberRowsRebuild = (chamberRows, numOfRows, numOfChambers) => (dispatch, getState) => {
  const state = getState();
  const { chamberType, chamberRowSpacing } = state.globals;
  const { totalStorageProvided } = state.calculations;
  const chamberbed = state.chamberbed;

  dispatch({
    type: CHAMBER_BED_CHAMBER_ROWS_REBUILD,
    payload: {
      chamberRows,
      numOfRows,
      numOfChambers,

      chamberType,
      chamberRowSpacing,
      totalStorageProvided,
      chamberbed,
      electedManifoldMetadata: {},
    },
  });
  dispatch({
    type: IS_DIRTY,
    payload: true,
  });
};

export const cleanChamberBed = () => (dispatch) => {
  dispatch({
    type: CHAMBER_BED_CLEAN,
  });
};

export const restoredStateBedRendered = () => (dispatch) => {
  dispatch({
    type: RESTORED_STATE_BED_RENDERED,
  });
};
export const updateNumberOfFeedConnectors = (data) => (dispatch) => {
  dispatch({
    type: NUMBER_OF_FEED_CONNECTORS,
    payload: data,
  });
};
export const updatePositionOfInspectionPort = (coordinates) => (dispatch) => {
  dispatch({
    type: POSITION_OF_INSPECTION_PORT,
    payload: coordinates,
  });
};



// WEBPACK FOOTER //
// ./src/actions/chamber-bed-actions.js